import { sortIcon } from "components/Icons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  ACCOUNTS_MANAGER,
  SURVEYORS_MANAGER,
} from "utils/constants";
import { roleCheck, sortByTypeAndName } from "utils/index";
import { getCurrentUser } from "../../reducers";
import TableRow from "./TableRow";

export default function SchedulesDateTable({
  jobServicesDay, calendarDateString, reloadData, surveyorOptions, bySection, readOnly
}) {
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role
  const [switchOrder, setSwitchOrder] = useState(true) // true = ascending (surveyors A-Z)
  const [sortedJobServices, setSortedJobServices] = useState(jobServicesDay)
  const isSurveyorManager = roleCheck(systemRole, currentTeamRole, SURVEYORS_MANAGER)
  const isAccountsManager = roleCheck(systemRole, currentTeamRole, ACCOUNTS_MANAGER)

  const sortJobServices = () => {
    const nextOrder = !switchOrder
    setSwitchOrder(nextOrder)
    const dataToSort = [...jobServicesDay]
    sortByTypeAndName(dataToSort, "surveyor_type", "surveyor_name", nextOrder)
    setSortedJobServices(dataToSort)
  }

  useEffect(() => {
    setSwitchOrder(true)
    const dataToSort = [...jobServicesDay]
    sortByTypeAndName(dataToSort, "surveyor_type", "surveyor_name", true)
    setSortedJobServices(dataToSort)
  }, [jobServicesDay])

  return (
    <div className="">
      <table className="table table-listing table-hover text-md">
        <thead>
          <tr>
            <th>Job No.</th>
            <th>Client Name</th>
            <th>Job Title</th>
            <th>Job Service</th>
            {!readOnly && (
              <th className="text-right">Value</th>
            )}
            <th className="text-center w-100px">Job Status</th>
            {(isSurveyorManager || isAccountsManager || !readOnly) && (
              <th className="text-center w-100px">Invoice Status</th>
            )}
            <th className="absorbing-column text-center">
              <span className="mr-1">Surveyor</span>
              <span type="button" onClick={() => sortJobServices()}>
                <img src={sortIcon} />
              </span>
            </th>
            <th className="text-center">
              <div>
                <div className="d-flex justify-content-center align-items-center w-100">
                  <div className="pr-2">
                    <span>Booking Time</span>
                    <span className="pr-2 d-block text-right small check-in-header">
                      <i>Check in</i>
                    </span>
                  </div>
                  <span type="button" onClick={() => sortJobServices()}>
                    <img src={sortIcon} />
                  </span>
                </div>
              </div>
            </th>
            <th className="text-center">ETA</th>
            <th>Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {!!sortedJobServices?.length && sortedJobServices.map(jobService => (
            <TableRow
              key={`row-${jobService.id}`}
              rowData={jobService}
              {...{
                calendarDateString, reloadData, surveyorOptions, bySection, readOnly
              }} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
